import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const dtcRoutes = [
  {
    path: 'dtc',
    name: 'DTC',
    component: () => import('@/features/dtc/views/DTC.vue'),
    meta: {
      title: `${t('dtc')} | Pour Now`,
      mainRouteName: 'DTC',
      permissionIdentifiers: [PERMISSIONS.CAN_VIEW_DTC_ACCOUNT],
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
